import React from "react";
import Navigation from "../common/Navigation";
import { correctHeight, detectBody } from "../common/Helpers";
import $ from "jquery";
import { withRouter } from "react-router-dom";
import { authenticationService } from "../../services/authentication.service";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import KeyboardEventHandler from "react-keyboard-event-handler";
import GlobalContext from "../../GlobalContext";

class Layout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentUser: authenticationService.currentUserValue
        };
    }

    displayName = Layout.name;

    handleKeyEvent(key) {
        if (key === "f9") {
            authenticationService.logout();
            this.props.history.push("/login");
        }
        if (key === "alt+l") {
            var language = this.context.language;
            switch (language) {
                case "sk":
                    language = "pl";
                    break;
                case "pl":
                    language = "cs";
                    break;
                default:
                    language = "sk";
            }
            localStorage.setItem("selectedLanguage", language);
            this.context.changeLanguage(language);
        }
    }

    render() {
        var localizationService = provideLocalizationService(this);
        document.title = localizationService.toLanguageString("LoginPage.Dodávky tovaru", "Dodávky tovaru") + " | GATE";

        const { currentUser } = this.state;
        let wrapperClass = "gray-bg " + this.props.location.pathname;
        return (
            <div id="wrapper">
                {currentUser ? (
                    <React.Fragment>
                        <KeyboardEventHandler handleKeys={["f9", "alt+l"]} onKeyEvent={(key, e) => this.handleKeyEvent(key)} />
                        <div id="page-wrapper" className={wrapperClass}>
                            <Navigation location={this.props.location} />

                            {this.props.children}

                            {/* <Footer /> */}
                        </div>
                    </React.Fragment>
                ) : (
                    <div id="login-wrapper" className={wrapperClass}>
                        {this.props.children}
                    </div>
                )}
            </div>
        );
    }

    componentDidMount() {
        var selectedLanguage = localStorage.getItem("selectedLanguage");
        if (selectedLanguage !== null) {
            this.context.changeLanguage(selectedLanguage);
        }

        // Run correctHeight function on load and resize window event
        $(window).bind("load resize", function() {
            correctHeight();
            detectBody();
        });

        // Correct height of wrapper after metisMenu animation.
        $(".metismenu a").click(() => {
            setTimeout(() => {
                correctHeight();
            }, 300);
        });
    }
}

export default withRouter(Layout);

Layout.contextType = GlobalContext;

registerForLocalization(Layout);



// WEBPACK FOOTER //
// ./src/components/layouts/Layout.js